import { render, staticRenderFns } from "./SystemGenerateId.vue?vue&type=template&id=1c9a704b&scoped=true"
import script from "./SystemGenerateId.vue?vue&type=script&lang=js"
export * from "./SystemGenerateId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9a704b",
  null
  
)

export default component.exports